import React from 'react';
import { ParallaxSection } from '../components/ParallaxSection';
import { SectionHeading } from '../components/SectionHeading';
const engineers = [{
  name: 'Robert Sinclair',
  title: 'Chief Engineer',
  specialization: 'Structural Engineering',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80',
  bio: '20+ years of experience leading complex structural projects across the Southeast.'
}, {
  name: 'Sarah Jenkins',
  title: 'Senior Civil Engineer',
  specialization: 'Site Development',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80',
  bio: 'Expert in urban planning and large-scale site infrastructure development.'
}, {
  name: 'Michael Chen',
  title: 'Lead Mechanical Engineer',
  specialization: 'HVAC Systems',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
  bio: 'Specializes in energy-efficient climate control systems for commercial towers.'
}, {
  name: 'David Rodriguez',
  title: 'Electrical Engineer',
  specialization: 'Power Systems',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80',
  bio: 'Focuses on sustainable power integration and smart building technologies.'
}, {
  name: 'Amanda Foster',
  title: 'Project Engineer',
  specialization: 'Construction Management',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80',
  bio: 'Coordinates cross-functional teams to ensure project milestones are met.'
}, {
  name: 'James Wilson',
  title: 'Safety Engineer',
  specialization: 'Risk Management',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80',
  bio: 'Dedicated to maintaining zero-incident worksites through rigorous protocols.'
}];
export function EngineersPage() {
  return <div className="bg-white min-h-screen" data-id="element-288" data-mp="1ecf5664dfsy1">
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&q=80" height="h-[50vh]" data-id="element-289" data-mp="bzsq2z9kvuei">
        <h1 className="text-5xl md:text-7xl font-bold font-serif text-white text-center" data-id="element-290" data-mp="gx2eqcp5821a">
          Our Engineers
        </h1>
      </ParallaxSection>

      <section className="py-20 px-4 md:px-8" data-id="element-291" data-mp="pztqkdlxkztg">
        <div className="max-w-7xl mx-auto" data-id="element-292" data-mp="pyinkg0b7w3e">
          <SectionHeading title="Technical Leadership" subtitle="Meet the minds behind our engineering excellence." data-id="element-293" data-mp="3pep2a7y01zqv" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-294" data-mp="3tga9pdrrllto">
            {engineers.map((eng, index) => <div key={index} className="group bg-white rounded-sm overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300" data-id="element-295" data-mp="70frxid9b0wm" data-mpi={index}>
                <div className="h-80 overflow-hidden" data-id="element-296" data-mp="35olmgbtsvnjl">
                  <img src={eng.image} alt={eng.name} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-297" data-mp="3ao81mqt6vdv1" />
                </div>
                <div className="p-6 border-b-4 border-[#C5A55A]" data-id="element-298" data-mp="2t7kamun0wkc3">
                  <h3 className="text-2xl font-bold font-serif text-black mb-1" data-id="element-299" data-mp="2t9x2bzil292c">
                    {eng.name}
                  </h3>
                  <p className="text-[#C5A55A] font-medium uppercase text-sm tracking-wide mb-2" data-id="element-300" data-mp="2k6vyy6l3qw2d">
                    {eng.title}
                  </p>
                  <p className="text-gray-500 text-sm italic mb-4" data-id="element-301" data-mp="2ff4fsh49zsm9">
                    {eng.specialization}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-302" data-mp="25i9j83rkc2am">
                    {eng.bio}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}